import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import staffUserSegments from "./staffUserSegments";
import signedInUserSegments from "./signedInUserSegments";
import userSegment from "./userSegment";
import tags from "./tags";
import organizations from "./organizations";
import groups from "./groups";
import notifications from "./notifications";

export default history =>
  combineReducers({
    router: connectRouter(history),
    staffUserSegments,
    signedInUserSegments,
    userSegment,
    tags,
    organizations,
    groups,
    notifications,
  });



// WEBPACK FOOTER //
// ./src/reducers/index.js